/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray, boolean as codecBoolean, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { CourseCouponUsage } from './CourseCouponUsage';
import { GlobalPermMap } from './GlobalPermMap';
import { TenantCouponUsage } from './TenantCouponUsage';
import { Transaction } from './Transaction';
import { User } from './User';
const ExtendedUserParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['email', /* #__PURE__ */ parsers.maybeNull(codecString)],
    ['hidden', codecBoolean],
    ['payments', /* #__PURE__ */ codecArray(Transaction)],
    [
        'usedCoupons',
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.taggedUnion('scope', [
            ['course', CourseCouponUsage],
            ['tenant', TenantCouponUsage],
        ])),
        'used_coupons',
    ],
    ['permissions', /* #__PURE__ */ codecOptional(GlobalPermMap)],
]), User);
export class ExtendedUser extends User {
    static decode(input) {
        return ExtendedUserParser.decode(input).map(res => new ExtendedUser(res));
    }
    static unsafeDecode(input) {
        return ExtendedUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedUserParser.encode(data);
    }
    static schema() {
        return ExtendedUserParser.schema();
    }
}
